var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"error 404"},[_c('h1',[_vm._v("404")]),_c('h1',[_vm._v("Page Not Found")]),_c('section',[_vm._v(" Maybe try the "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("home page")]),_vm._v("? ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }